import { CSSProperties } from "react";
import { twMerge } from "tailwind-merge";

import { GrowinColors } from "@/colors";

import styles from "./Checkbox.module.scss";
import { CheckboxProps } from "./CheckboxProps";

const Checkbox = ({
  id,
  children,
  checked,
  onChange,
  checkboxColor = GrowinColors["data-primary"],
  hoverColor = "rgba(0, 119, 255, 0.06)",
  disabled = false,
  fontSize,
}: CheckboxProps) => {
  return (
    <div
      role="checkbox"
      aria-disabled={disabled}
      aria-checked={checked}
      className={twMerge(
        styles["checkbox"],
        disabled ? "pointer-events-none" : ""
      )}
      style={
        {
          "--checkbox-color": checkboxColor,
          "--hover-color": hoverColor,
        } as CSSProperties
      }
    >
      <input
        className={styles["inp-cbx"]}
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <label className={twMerge(styles["cbx"], "flex")} htmlFor={id}>
        <span className="shrink-0">
          <svg width="12px" height="10px">
            <use xlinkHref="#check"></use>
          </svg>
        </span>
        <span
          style={
            {
              fontSize,
            } as CSSProperties
          }
          className={twMerge(disabled ? "text-neutral-400" : "")}
        >
          {children}
        </span>
      </label>
      <svg className={styles["inline-svg"]}>
        <symbol id="check" viewBox="0 0 12 10">
          <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
        </symbol>
      </svg>
    </div>
  );
};

export default Checkbox;
